import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Flex, media } from 'lib/style-utils';

const Wrapper = styled.div`
  max-width: 1039px;
  width: 100%;
  margin: 0 auto;
  padding: 0 10px;
`;

const Location = styled.div`
  margin: 124px 0 19px;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-align: center;
  color: #343434;

  ${media.mobile`
    font-size: 18px;
  `}
`;

const Eng = styled.span`
  font-family: Lato;
  font-weight: 700;
  color: #666666;
`;

const Table = Flex.extend`
  width: 100%;
  flex-direction: column;
  border-collapse: collapse;
`;

const Tr = Flex.extend`
  width: 100%;
  height: 96px;
  border-bottom: 1px solid #eeeeee;

  &.first-tr {
    border-top: 1px solid #dddddd;
  }

  ${media.w800`
    flex-direction: column;
    height: auto;
  `}
`;

const Th = styled.div`
  width: 35%;
  text-align: left;
  font-family: 'Noto Sans KR';
  font-size: 17px;
	font-weight: 500;
	letter-spacing: 0.5px;
  color: #343434;

  ${media.w800`
    width: 100%;
    text-align: center;
    padding: 30px 0 10px;
  `}
`;

const Td = styled.div`
  float: left;
  width: 40%;
  text-align: left;
  font-family: 'Noto Sans KR';
	font-size: 16px;
	letter-spacing: 0.5px;
  color: #777777;
  word-break: keep-all;
  line-height: 1.5;

  ${media.w800`
    width: 100%;
    text-align: center;
    padding: 10px 0 10px;
  `}

  &.last-td {
    width: 25%;
    text-align: right;

    ${media.w800`
      width: 100%;
      text-align: center;
      padding: 10px 0 30px;
    `}
  }
`;

const Bold = styled.span`
  font-weight: 700;
`;

const Btn = styled.button`
  width: 150px;
  height: 45px;
  background: #fff;
  color: #aaaaaa;
  border: 1px solid #eeeeee;
  border-radius: 25px;
  font-family: Lato;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 0.7px;
  cursor: pointer;

  &:hover {
    background: #f9f9f9;
  }

  &:active {
    background: #f2f2f2;
    transform: translateY(1px);
  }
`;

class OfflineShop extends PureComponent {
  render() {
    return (
      <Wrapper>
        <Location>서울 <Eng>SEOUL</Eng></Location>
        <Table>
          <Tr className="first-tr">
            <Th>구름바이에이치 쇼룸</Th>
            <Td><Bold>주소</Bold> 서울시 서초구 방배로 43길 50-2 1층</Td>
            <Td className="last-td"><a href="http://naver.me/GO4X30F0" target="_blank" rel="noopener noreferrer"><Btn>VIEW MAP</Btn></a></Td>
          </Tr>
        </Table>
      </Wrapper>
    );
  };
}

class OnlineShop extends PureComponent {
  render() {
    return (
      <Wrapper>
        <Location/>
        <Table>
          <Tr className="first-tr">
            <Th>1300K</Th>
            <Td><a href="http://www.1300k.com" target="_blank" rel="noopener noreferrer">http://www.1300k.com</a></Td>
            <Td className="last-td"><a href="http://www.1300k.com" target="_blank" rel="noopener noreferrer"><Btn>GO TO SHOP</Btn></a></Td>
          </Tr>
        </Table>
      </Wrapper>
    );
  };
}

export {
  OfflineShop,
  OnlineShop
};



// WEBPACK FOOTER //
// ./src/components/Shoplist/Shop.js